import template from './report_leave_per_day.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeavePerDayViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.date_start = ko.observable(moment().format('YYYY-MM'));
		this.refresh_button = ko.observable(false);
		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.total_leave_in_company = ko.observable(0);
		this.department_with_most_leave = ko.observable('None');
		this.department_leave_total = ko.observable(0);
		this.leave_types = ko.observableArray();
		this.selected_leave_types = ko.observableArray();
		this.available_leave_types = ko.observableArray();

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.selected_leave_types.subscribe(() => {
			this.page.updateData();
		});

		this.date_start.subscribe((newValue) => {
			this.page.updateData();
		});

		this.selected_options_text = ko.computed(() => {
			let selected_ids = this.selected_leave_types();
			if (selected_ids.length === 0) return "View leave type options";
			
			if (selected_ids.length > 3) return `${selected_ids.length} leave types selected`;

			let selected_desc = this.leave_types().filter(option => selected_ids.includes(option.leave_type_id)).map(option => option.description);
			return selected_desc.join(", ");
		});
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveTakenPerDayCountHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	graph_option_click (row)
	{
		let selected_options = this.selected_leave_types();

		if (selected_options.indexOf(row.leave_type_id) == -1)
			this.selected_leave_types.push(row.leave_type_id);
		else
			this.selected_leave_types.remove(row.leave_type_id);

		this.refresh_button(true);
		return true;
	}
}

class ReportLeavePerDayPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeavePerDayViewModel(this);
		this.chart;
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('LeaveDaysTakenPerMonthReport'))
			return;

		document.title = tr('Leave Taken Per Day Count');
		window.current_page_title(tr('Leave Taken Per Day Count'));

		let res = await Grape.fetches.getJSON('/api/record', { table: 'leave_type', limit: 100 });
		this.viewModel.leave_types(res.records);

		this.setupGraph();
		this.updateData();
	}

	async updateData()
	{
		if (this.viewModel.date_start() != '' && this.viewModel.date_start() != undefined)
		{
			let today = new Date(this.viewModel.date_start());
			let firstDay = today.setDate(1);
			let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);

			let data = {
				department_id: this.viewModel.current_department_id(),
				date_start: new Date(firstDay).toJSON().slice(0, 10),
				date_end: new Date(lastDay).toJSON().slice(0, 10),
				leave_type_ids:  this.viewModel.selected_leave_types()
			};

			this.viewModel.loader(true);
			let res = await Grape.fetches.postJSON('/report_graphs/leave_per_day', data);

			if (res)
			{
				this.buildGraph(res);
				this.viewModel.loader(false);
				this.viewModel.refresh_button(false); // hide refresh button
			}
		}
	}

	setupGraph()
	{
		this.chart = c3.generate({
			size: {
				height: 400
			},
			data: {
				x: 'x',
				columns: [
					/* ['x', 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife' , 'Platsoft', 'Skinchem', 'Maths', 'IG' , 'QC' , 'Platlife'],
					['Leave %', 30, 70, 100, 100, 100, 50, 30, 70, 100, 100, 100, 50] */
				],
				colors: {
					'Leave days': '#31859D'
				},
				type: 'bar',
				labels: {
					format: {
						// "Leave %": d3.format('%')
						'Leave days': function (v, id, i, j) { return v; }
					}
				}
			},
			transition: {
				duration: 1
			},
			legend: {
				show: false
			},
			bar: {
				width: {
					ratio: 0.7 // this makes bar width 50% of length between ticks
				}
			},
			axis: {
				x: {
					type: 'category' // this needed to load string x value
					/* label: {
						text: 'Departments',
						position: 'outer-center'
					} */

				}
			}
		});
	}

	buildGraph(res)
	{
		if (res != null)
		{
			// reset
			this.viewModel.total_leave_in_company(0);
			this.viewModel.department_with_most_leave('None');
			this.viewModel.department_leave_total(0);

			let labelArray = ['x'];
			let dataArray = [tr('Leave days')];
			let highest = 0;
			let days_with_highest_leave = []; // Array to store all days with highest leave

			let total_leave_days = 0;

			for (let a = 0; a < res.days.length; a++)
			{
				labelArray.push(String(res.days[a].day).slice(8, 10));
				dataArray.push(res.days[a].amount.toFixed(2));
				total_leave_days += res.days[a].amount;

				// Check if this day has more leave than current highest
				if (Number(res.days[a].amount) > Number(highest))
				{
					highest = res.days[a].amount;
					// Reset array with new highest day
					days_with_highest_leave = [String(res.days[a].day).slice(0, 10)];
					this.viewModel.department_leave_total((res.days[a].amount).toFixed(2));
				}
				// Check if this day ties for highest leave
				else if (Number(res.days[a].amount) === Number(highest) && highest > 0)
				{
					// Add to array if not already present
					let dayString = String(res.days[a].day).slice(0, 10);
					if (!days_with_highest_leave.includes(dayString)) 
						days_with_highest_leave.push(dayString);
				}
			}

			// Set the department_with_most_leave to show all days with highest leave
			if (days_with_highest_leave.length > 0) 
				this.viewModel.department_with_most_leave(days_with_highest_leave.join(', '));
			else 
				this.viewModel.department_with_most_leave('None');

			this.viewModel.total_leave_in_company(total_leave_days.toFixed(2));
			this.chart.unload(); // clear chart
			setTimeout(() => {
				this.chart.load({
					columns: [
						labelArray,
						dataArray
					]
				});
			}, 1100);
		}
		else
		{
			this.chart.unload(); // clear chart
			this.viewModel.total_leave_in_company(0);
			this.viewModel.department_with_most_leave('None');
			this.viewModel.department_leave_total(0);
		}
	}

	/* Not used currently
	remove_filter(v, e)
	{
		if ($(e.currentTarget).prop('checked') == false)
			if (leave_types_ticked_filter.indexOf(v.leave_type_id) > -1)
				leave_types_ticked_filter.splice(leave_types_ticked_filter.indexOf(v.leave_type_id), 1);
		else
			if (leave_types_ticked_filter.indexOf(v.leave_type_id) == -1)
				leave_types_ticked_filter.push(v.leave_type_id);

		this.viewModel.refresh_button(true); // show refresh button
		return true;
	}
	*/
}

export default {
	route: '[/]report/report_leave_per_day',
	page_class: ReportLeavePerDayPage,
	template: template,
	template_filename: 'translation/report_leave_per_day'
};
